/* eslint-disable react/no-danger */
import React from 'react';
import Img from 'gatsby-image';
import { FaQuoteLeft } from 'react-icons/fa';
import WrongImagePlaceholder from '../WrongImagePlaceholder';

const ResultTestimonial = ({ versionPillar, caseStudy, content }) => {
  return (
    <div
      className={`storey ${
        caseStudy.frontmatter.testimonial.lightMode ? 'light-mode' : ''
      }`}
    >
      <div className="bg">
        <div className="container" />
      </div>
      <div className="container">
        <div className="row">
          <div className={` ${versionPillar ? 'col' : 'col-xl-6'}`}>
            <div className="subtitle without bigger">
              <h2>{(content && content.customTitle) || 'Testimonial'}</h2>
              <h4 className="extra">
                {(content && content.customSubtitle) ||
                  'Customer opinions proves we are trustworthy.'}
              </h4>
            </div>
          </div>
        </div>
        <div className="opinion-block">
          <div className="left-pistil">
            <div className="author">
              {caseStudy.frontmatter.testimonial.author.photo ? (
                <Img
                  fixed={
                    caseStudy.frontmatter.testimonial.author.photo
                      .childImageSharp.fixed
                  }
                  alt={`${caseStudy.frontmatter.testimonial.author.title}`}
                  title={caseStudy.frontmatter.testimonial.author.title}
                  className="img-fluid"
                />
              ) : (
                <WrongImagePlaceholder />
              )}{' '}
              <div className="neck">
                <div className="name">
                  {caseStudy.frontmatter.testimonial.author.title}
                </div>
                <div className="description">
                  {caseStudy.frontmatter.testimonial.author.subtitle}
                </div>
              </div>
            </div>
            <div className="company">
              <Img
                fixed={caseStudy.frontmatter.images.logo.childImageSharp.fixed}
                className="img-fluid logo"
                alt={`${caseStudy.frontmatter.title} company logo`}
                title={caseStudy.frontmatter.title}
                objectFit="contain"
              />
            </div>
          </div>
          <div className="right-pistil">
            <div className="opinion">
              <FaQuoteLeft className="quote-top" />
              <div
                dangerouslySetInnerHTML={{
                  __html: caseStudy.frontmatter.testimonial.content
                }}
              />
              <FaQuoteLeft className="quote-bottom" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResultTestimonial;
